import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CALL_STATUS } from "./constants";
import mediaAPI from "../../api/media";
import { blockMedia, unblockMedia, blockUser } from "./media.reducer";

const initialState = {
    status: CALL_STATUS.IDLE,
    error: null,
    data: []
};

export const getReportedMedia = createAsyncThunk('reports/getReportedMedia', async (token) => {
    const response = await mediaAPI.getReportedMedia(token);
    return response;
});

const reportsSlice = createSlice({
    name: "reports",
    initialState,
    reducers: {
        reset: () => initialState
    },
    extraReducers: (builder) => {
        builder
            .addCase(getReportedMedia.pending, (state) => {
                state.status = CALL_STATUS.PENDING;
                state.error = null;
            })
            .addCase(getReportedMedia.fulfilled, (state, action) => {
                state.status = CALL_STATUS.SUCCESS;
                state.data = action.payload.data;
            })
            .addCase(getReportedMedia.rejected, (state, action) => {
                state.status = CALL_STATUS.ERROR;
                state.error = action.error.message;
            })
            .addCase(blockMedia.fulfilled, (state, action) => {
                const media = state.data.find(item => item.id === action.payload);
                if (media) {
                    media.status = 'BLOCKED';
                }
            })
            .addCase(unblockMedia.fulfilled, (state, action) => {
                const media = state.data.find(item => item.id === action.payload);
                if (media) {
                    media.status = 'HISTORY';
                }
            })
            .addCase(blockUser.fulfilled, (state, action) => {
                if (action.meta.arg.blockVideos) {
                    if (state.data) {
                        const userId = action.payload;
                        state.data = state.data.filter(media => media.ownerId !== userId);
                    }
                }
            });
    }
});

const { actions, reducer } = reportsSlice;

export const { reset } = actions;

export default reducer;